import { useAppSelector } from '@user/store/hooks'
import { FEATURES } from '@sales-center/common/tenantFeatures'
import { selectTenantFeatureById } from '@user/store/tenantFeatures'

export function useUnifiedCalendarEnabled() {
  const feature = useAppSelector((state) =>
    selectTenantFeatureById(state, FEATURES.UnifiedCalendar),
  )

  return feature?.enabled ?? false
}
